import { Context as PosContext } from '@squareup/sq-addons-web-sdk';

import {
  FETCH_CONTEXT,
  FETCH_CONTEXT_FULFILLED,
  FETCH_CONTEXT_REJECTED,
  FetchContextAction,
  FetchContextFulfilledAction,
  FetchContextRejectedAction,
} from './types';

export function fetchContext(
  getPosContext: () => Promise<PosContext>
): FetchContextAction {
  return {
    type: FETCH_CONTEXT,
    payload: { getPosContext },
  };
}

export function fetchContextFulfilled(
  posContext: PosContext
): FetchContextFulfilledAction {
  return {
    type: FETCH_CONTEXT_FULFILLED,
    payload: { posContext },
  };
}

export function fetchContextRejected(error: Error): FetchContextRejectedAction {
  return {
    type: FETCH_CONTEXT_REJECTED,
    payload: { error },
  };
}
